import type { CSSProperties } from 'react';

export const DIALOG_STYLE: CSSProperties = { '--dialog-width': 'auto' } as CSSProperties;

export const FILE_UPLOAD_CTA_INPUT_ID = 'expressDesignerFileUpload';
